import { render, staticRenderFns } from "./Inputtype.vue?vue&type=template&id=7f89429e&"
import script from "./Inputtype.vue?vue&type=script&lang=js&"
export * from "./Inputtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports